import * as en from './en';

export const resources = {
  en,
} as const;
